import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getTokens } from '../../../api-services/auth';

function AuthGuard({ children }) {
  const location = useLocation()
  const token = getTokens()

  if (!token?.accessToken) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} />;
  }

  return children;
}

export default AuthGuard;